export default {
  LOGIN: "/login",
  EMPLOYEES: "/employees",
  EMPLOYEE_CREATE: "/employees/create",
  EMPLOYEE_DETAILS: "/employees/details/",
  EMPLOYEE_UPDATE: "/employees/update/",
  EMPLOYEE_INFORMATION: "/employees/details/",

  LOCATIONS: "/locations",
  LOCATIONS_CREATE: "/locations/create",
  LOCATIONS_UPDATE: "/locations/update/",
  LOCATIONS_DETAILS: "/locations/details/",
  MACHINES: "/machines",
  DEPARTMENT: "/department",
  DEPARTMENT_CREATE: "/department/create",
  DEPARTMENT_UPDATE: "/department/update/",
  DEPARTMENT_DETAILS: "/department/details/",

  UNIT: "/unit",
  CATEGORY: "/category",
  SUBCATEGORY: "/subcategory/",
  PRODUCT: "/product",
  PRODUCT_CREATE: "/product/create",
  PRODUCT_UPDATE: "/product/update/",
  FEEDBACK_FORM: "/feedback",
  POSITIVE_FEEDBACK_FORM: "/feedback/positive",
  NEGATIVE_FEEDBACK_FORM: "/feedback/detail",
  COMPLETION_SCREEN: "/feedback/submit", // CompletionScreen
  // PRODUCT_LIST:"/product/",
  USER_ROLES: "/roles/",
  USER_ROLES_CREATE: "/roles/create",
  USER_ROLES_UPDATE: "/roles/update/",
  USER_ROLES_DETAIL: "/roles/detail/",
   STATIC_QR:"/static/qr",
     SHIFTS:"/shifts",
     SHIFTS_DETAILS:"/shifts/detail/",
  CALENDAR:"/calendar",
  ATTENDACE_REPORT:"/attendace/report",
  MUSTER_REPORT:"/muster/report",
  SALARY_REPORT:"/salary/report",
  SHIFTS_WISE_REPORT:"/shifts/report",

  GRADE_MASTER: "/grade",
};
